module.exports = __webpack_public_path__ + "static/img/wechat.555461e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/wechat.png
// module id = prkE
// module chunks = 1